import http from "./http";

// Upload single or multiple files
export const uploadOperatorFiles = async ({ school_id, file_name, description, files, file }) => {
  const formData = new FormData();
  formData.append("action", "upload");
  formData.append("school_id", school_id);
  formData.append("file_name", file_name);
  if (description) {
    formData.append("description", description);
  }

  if (files && files.length > 0) {
    if (files.length === 1) {
      formData.append("file", files[0]);
    } else {
      Array.from(files).forEach((f) => {
        formData.append("files[]", f);
      });
    }
  } else if (file) {
    formData.append("file", file);
  }

  const response = await http.post("operator/operator_files.php", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};

// Get files (optionally filtered by school_id)
export const getOperatorFiles = async (school_id = null) => {
  const url = school_id
    ? `operator/operator_files.php?action=get_files&school_id=${school_id}`
    : `operator/operator_files.php?action=get_files`;

  const response = await http.post(url);
  return response.data;
};

// Update upload details
export const updateOperatorFile = async ({ upload_id, title, description, document_id, document_title, file }) => {
  const formData = new FormData();
  formData.append("upload_id", upload_id);
  if (title) formData.append("title", title);
  if (description) formData.append("description", description);
  if (document_id) formData.append("document_id", document_id);
  if (document_title) formData.append("document_title", document_title);
  if (file) formData.append("file", file);

  const response = await http.post("operator/operator_files.php?action=update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};

// Delete single file from upload (if needed in future)
export const deleteOperatorDocument = async (document_id) => {
  const formData = new FormData();
  formData.append("document_id", document_id);

  const response = await http.post("operator/operator_files.php?action=delete_file", formData);
  return response.data;
};

// Delete main upload (if needed in future)
export const deleteOperatorUpload = async (upload_id) => {
  const formData = new FormData();
  formData.append("upload_id", upload_id);

  const response = await http.post("operator/operator_files.php?action=delete_main", formData);
  return response.data;
};
